import type { RouteRecordRaw } from 'vue-router';
import { RUNNER_ROUTE_NAME } from '@/utils/reports/reportsCatalog';

/**
 * Reports Center (#645). Neither route carries a permission gate: the server
 * lists only the reports a user may run and refuses the rest, and the page
 * cards for older reports are filtered by those pages' own permissions.
 */
export const reportsRoutes: RouteRecordRaw[] = [
  {
    path: 'reports',
    name: 'admin-reports-center',
    component: () => import('@/views/AdminDashboard/Reports/ReportsCenterView.vue'),
    meta: { requiresAuth: true, title: 'Reports Center' },
  },
  {
    path: 'reports/run/:key',
    name: RUNNER_ROUTE_NAME,
    component: () => import('@/views/AdminDashboard/Reports/ReportRunnerView.vue'),
    meta: { requiresAuth: true, title: 'Run Report' },
  },
];
